import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { SCREENS } from "@educaplay/store/constants";

/**
 * Hook personalizado para manejar el estado del juego de sopa de letras
 */
export const useGameState = () => {
  const questions = useSelector((state) => state.game.questions);
  const currentQuestionIndex = useSelector((state) => state.game.currentIndex);
  const currentQuestion = useSelector(
    (state) => state.game.questions[state.game.currentIndex]
  );

  const tiles = useSelector((state) => {
    const question = state.game.questions[state.game.currentIndex];
    return question.tiles;
  });

  const words = useSelector((state) => {
    const question = state.game.questions[state.game.currentIndex];
    return question.correctAnswers;
  });

  const time = useSelector(
    (state) => state.game.questions[state.game.currentIndex].time
  );

  const hasFinished = useSelector((state) => state.game.view) === SCREENS.SCORE_SCREEN;
  const penalties = useSelector((state) => state.game.liveActived);
  const isAnimating = useSelector((state) => state.game.isAnimating);

  const [activeSelector, setActiveSelector] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  const [foundWordsArray, setFoundWordsArray] = useState([]);
  const [gridShown, setGridShown] = useState(false);

  const tileRefs = useRef([]);
  const gridRef = useRef();

  return {
    questions,
    currentQuestionIndex,
    currentQuestion,
    tiles,
    words,
    time,
    hasFinished,
    penalties,
    isAnimating,
    gridSize: currentQuestion.gridSize,
    activeSelector,
    setActiveSelector,
    userAnswers,
    setUserAnswers,
    foundWordsArray,
    setFoundWordsArray,
    gridShown,
    setGridShown,
    tileRefs,
    gridRef
  };
};
